import { Icons } from './Icons';

interface CoverUploadProps {
  coverUrl: string;
  isDragging: boolean;
  isUploading: boolean;
  label: string;
  description: string;
  aspectRatio?: '3/2' | '2/3';
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: () => void;
  onDrop: (e: React.DragEvent) => void;
  onRemove: () => void;
}

export function CoverUpload({
  coverUrl,
  isDragging,
  isUploading,
  label,
  description,
  aspectRatio = '3/2',
  onDragOver,
  onDragLeave,
  onDrop,
  onRemove
}: CoverUploadProps) {
  const aspectClass = aspectRatio === '2/3' ? 'aspect-[2/3]' : 'aspect-[3/2]';
  
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-stone-600">{label}</label>
      <div 
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        className={`relative rounded-xl border-2 border-dashed transition-all overflow-hidden ${
          isDragging 
            ? 'border-teal-400 bg-teal-50/50' 
            : coverUrl 
              ? 'border-stone-200' 
              : 'border-stone-300 hover:border-stone-400'
        }`}
      >
        {coverUrl ? (
          <div className={`relative ${aspectClass} max-h-64`}>
            <img src={coverUrl} alt={label} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/0 hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 hover:opacity-100">
              <button
                onClick={onRemove}
                className="px-4 py-2 bg-white rounded-lg text-sm font-medium text-stone-700 shadow-lg"
              >
                Change Image
              </button>
            </div>
          </div>
        ) : isUploading ? (
          <div className={`${aspectClass} max-h-64 flex flex-col items-center justify-center text-stone-400`}>
            <div className="w-8 h-8 border-2 border-stone-200 border-t-teal-500 rounded-full animate-spin mb-3" />
            <span className="text-sm">Uploading...</span>
          </div>
        ) : (
          <div className={`${aspectClass} max-h-64 flex flex-col items-center justify-center text-stone-400 p-8`}>
            <Icons.Image />
            <span className="text-sm mt-2">{description}</span>
            <span className="text-xs text-stone-300 mt-1">Drop image here or click to browse</span>
          </div>
        )}
      </div>
    </div>
  );
}
